import { Utility } from './../shared/utility';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { State, process, aggregateBy } from '@progress/kendo-data-query';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { InvoiceService } from 'src/app/shared/services/invoices/invoice.service';
import { PaymentsService } from 'src/app/shared/services/profile/payments.service';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./invoice.component.css']
})

export class InvoiceComponent implements OnInit {
  pastDueInvoices: any[];
  dueInvoices: any[];
  state: State = {
    skip: 0,
    sort: []
  };
  operators: any;
  paidInvoices: any[];
  expandedDetailKeys: any[];
  currencyFormatter: Intl.NumberFormat;
  enablePayBtn: boolean;
  config: any;
  resetSelection: boolean;
  openDialog: boolean;
  loading: boolean;
  total: any;
  pendingInvoices: any[];
  inputData: { userInfo: any; };
  ids = [];
  gridLoaded: any;
  noInfo: any;
  selectedTab: number;
  invoiceData: {
    tabTitle: string; data: {
      title: string; invoiceType: string;
      data: { data: any[]; total: number; }; id: string; error: boolean; shouldDisplay: boolean;
    }[]; show: boolean;
  }[];
  initialLoading: boolean;
  disclaimer: any;

  constructor(
    private router: Router,
    private authService: AuthService,
    private usersService: UsersService,
    private invoiceService: InvoiceService,
    private paymentsService: PaymentsService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    if (this.authService.isLoggedIn) {
      this.authService.loggedInChecker(this.authService.isLoggedIn);
    }
    this.notificationService.setUpLoading(true);
    this.inputData = {
      userInfo: this.usersService.UserInfo()
    };
    this.config = this.readConfigService.getInvoiceText();
    this.getAllInvoices();
  }

  getAllInvoices() {
    this.notificationService.setUpLoading(true);
    this.initialLoading = true;
    this.invoiceData = [{
      tabTitle: 'Unpaid Payments',
      data: [
        { title: 'Past Due', invoiceType: 'Past Due', data: { data: [], total: 0 }, id: 'past-due', error: false, shouldDisplay: true },
        { title: 'Due', invoiceType: 'Due', data: { data: [], total: 0 }, id: 'due', error: false, shouldDisplay: true }],
      show: false
    }, {
      tabTitle: 'Initiated Payments',
      data: [
        {
          title: 'Initiated Payments', invoiceType: 'Initiated Payments',
          data: { data: [], total: 0 }, id: 'initiated', error: false, shouldDisplay: true
        }
      ],
      show: false
    }, {
      tabTitle: 'Paid Payments',
      data: [
        { title: 'Paid', invoiceType: 'Paid', data: { data: [], total: 0 }, id: 'paid', error: false, shouldDisplay: true }
      ],
      show: false
    }];
    this.selectedTab = 0;
    this.total = 0;
    this.enablePayBtn = false;
    this.resetSelection = true;
    this.gridLoaded = { a: false, b: false, c: false, d: false };
    this.dueInvoices = [];
    this.pastDueInvoices = [];
    this.pendingInvoices = [];
    this.paidInvoices = [];
    this.expandedDetailKeys = ['Past Due', 'Due'];
    this.getEmpACHStatus();
  }

  getPastDueInvoices() {
    this.invoiceService.getPastDueInvoices(this.inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.result) {
        data.result.forEach((element) => {
          element.dueDate = Utility.removeTimeFromDate(element.dueDate);
          element.invoiceDate = new Date(element.invoiceDate);
        });
        this.pastDueInvoices = data.result.filter((s: any) => s.amount !== 0);
        this.invoiceData[0].data[0].data = process(data.result, this.state);
        const result = aggregateBy(this.pastDueInvoices, [
          { aggregate: 'sum', field: 'amount' }
        ]);
        if (result && result.amount && result.amount.sum) {
          this.invoiceData[0].data[0].title = this.invoiceData[0].data[0].title + ' ' + Utility.checkNegativeAmount(result.amount.sum);
        } else {
          this.invoiceData[0].data[0].title = this.invoiceData[0].data[0].title + ' ' + '$0.00';
        }
      } else if (data && data.statusCode === 204) {
        this.pastDueInvoices = [];
        this.invoiceData[0].data[0].shouldDisplay = false;
        this.invoiceData[0].data[0].data = process(this.pastDueInvoices, this.state);
        this.invoiceData[0].data[0].title = this.invoiceData[0].data[0].title + ' ' + '$0.00';
      } else if (data && data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.invoiceData[0].data[0].error = true;
      }
      this.gridLoaded.a = true;
      this.getDueInvoices();
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.gridLoaded.a = true;
        this.invoiceData[0].data[0].error = true;
        this.getDueInvoices();
      });
  }

  getDueInvoices() {
    this.invoiceService.getDueInvoices(this.inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.result) {
        data.result.forEach((element) => {
          element.dueDate = element.amount < 0 ? null : Utility.removeTimeFromDate(element.dueDate);
          element.invoiceDate = new Date(element.invoiceDate);
        });
        this.dueInvoices = data.result.filter((s: any) => s.amount !== 0);
        this.invoiceData[0].data[1].data = process(this.dueInvoices, this.state);
        const result = aggregateBy(this.dueInvoices, [
          { aggregate: 'sum', field: 'amount' }
        ]);
        if (result && result.amount && result.amount.sum) {
          this.invoiceData[0].data[1].title = this.invoiceData[0].data[1].title + ' ' + Utility.checkNegativeAmount(result.amount.sum);
        } else {
          this.invoiceData[0].data[1].title = this.invoiceData[0].data[1].title + ' ' + '$0.00';
        }
      } else if (data && data.statusCode === 204) {
        this.dueInvoices = [];
        this.invoiceData[0].data[1].data = process(this.dueInvoices, this.state);
        this.invoiceData[0].data[1].title = this.invoiceData[0].data[1].title + ' ' + '$0.00';
      } else if (data && data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.invoiceData[0].data[1].error = true;
      }
      this.notificationService.setUpLoading(false);
      this.setTabStripStyle();
      this.gridLoaded.b = true;
      this.invoiceData[0].show = true;
      this.initialLoading = false;
      this.checkPastDueEmpty();
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.gridLoaded.b = true;
        this.invoiceData[0].data[1].error = true;
        this.notificationService.setUpLoading(false);
        this.setTabStripStyle();
        this.invoiceData[0].show = true;
        this.initialLoading = false;
      });
  }

  checkPastDueEmpty() {
    if (this.pastDueInvoices.length === 0) {
      setTimeout(() => {
        const mainGrid = document.querySelectorAll('#invoice-grid');
        if (mainGrid.length > 0) {
          const pastGrid = document.querySelectorAll('#invoice-grid tbody tr')[0] as HTMLElement;
          pastGrid.style.display = 'none';
        }
      }, 50);
    }
  }

  getPendingInvoices() {
    this.invoiceService.getPendingInvoices(this.inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.result) {
        data.result.forEach((element) => {
          element.invoiceDate = new Date(element.invoiceDate);
          element.paidDate = new Date(element.paidDate);
        });
        this.pendingInvoices = data.result.filter((s: any) => s.amount !== 0);
        this.invoiceData[1].data[0].data = process(this.pendingInvoices, this.state);
      } else if (data && data.statusCode === 204) {
        this.pendingInvoices = [];
        this.invoiceData[1].data[0].data = process(this.pendingInvoices, this.state);
      } else if (data && data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.invoiceData[1].data[0].error = true;
      }
      this.gridLoaded.c = true;
      this.invoiceData[1].show = true;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.gridLoaded.c = true;
        this.invoiceData[1].data[0].error = true;
        this.invoiceData[1].show = true;
      });
  }

  getPaidInvoices() {
    this.invoiceService.getPaidInvoices(this.inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.result) {
        data.result.forEach((element) => {
          element.invoiceDate = new Date(element.invoiceDate);
          element.paidDate = new Date(element.paidDate);
        });
        this.paidInvoices = data.result.filter((s: any) => s.amount !== 0);
        this.invoiceData[2].data[0].data = process(this.paidInvoices, this.state);
      } else if (data && data.statusCode === 204) {
        this.paidInvoices = [];
        this.invoiceData[2].data[0].data = process(this.paidInvoices, this.state);
      } else if (data && data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.invoiceData[2].data[0].error = true;
      }
      this.gridLoaded.d = true;
      this.invoiceData[2].show = true;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.gridLoaded.d = true;
        this.invoiceData[2].data[0].error = true;
        this.invoiceData[2].show = true;
      });
  }

  setTabStripStyle() {
    const allDetails = document.querySelectorAll('.k-tabstrip');
    if (allDetails && allDetails.length > 0) {
      allDetails.forEach(details => {
        const firstChild = details.firstElementChild.children[0];
        if (firstChild && firstChild.children && firstChild.children.length > 1) {
          const elArr = Array.from(firstChild.children) as Array<HTMLElement>;
          const tabFirstEl = Array.from(elArr[0].children) as Array<HTMLElement>;
          const tabSecEl = Array.from(elArr[1].children) as Array<HTMLElement>;
          tabFirstEl[0].style.marginRight = '5px';
          tabSecEl[0].style.marginRight = '5px';
          elArr.forEach(element => {
            element.style.width = 100 / firstChild.children.length + '%';
          });
        }
      });
    }
  }

  negativeAmount(amount) {
    return Utility.checkNegativeAmount(amount);
  }

  selectionEvent(e: any) {
    if (e && e.selectionEvent) {
      const event = e.selectionEvent;
      if (event.selectedRows.length > 0) {
        const dataItem = event.selectedRows[0].dataItem;
        const index = this.ids.findIndex(x => x.id === dataItem.id);
        if (index > -1) {
          this.ids.splice(index, 1);
        }
        this.ids.push({
          id: dataItem.id, InvoiceId: dataItem.id,
          ScheduledDate: dataItem.scheduledDate || dataItem.scheduledDateAfterCutoff,
          ShowDateError: dataItem.showDateError,
          DueDate: dataItem.dueDate, SubmitDate: new Date(), InvoiceNo: dataItem.invoiceNumber, InvoiceAmount: dataItem.amount
        });
        this.total = Math.round((this.total + dataItem.amount) * 100) / 100;
      } else if (event.deselectedRows.length > 0) {
        const dataItem = event.deselectedRows[0].dataItem;
        const index = this.ids.findIndex(x => x.id === dataItem.id);
        this.ids.splice(index, 1);
        this.total = Math.round((this.total - dataItem.amount) * 100) / 100;
      }
      if (this.ids.some(x => x.ShowDateError)) {
        this.enablePayBtn = false;
      } else {
        this.enablePayBtn = this.ids && this.ids.length > 0;
      }
      this.resetSelection = false;
    }
    if (this.ids.length === 0) {
      this.total = 0;
    }
  }

  onDateChange(event: any) {
    if (event) {
      const e = event.selectionEvent;
      this.enablePayBtn = !(e && e.showDateError);
      for (const item of this.ids) {
        if (e.id === item.id) {
          item.ScheduledDate = e.scheduledDate;
          item.ShowDateError = e.showDateError;
        }
      }
      if (this.enablePayBtn && event.isDateError) {
        this.enablePayBtn = false;
      }
    }
  }

  onTabSelect(e: any) {
    if (e) {
      this.selectedTab = e.index;
      switch (this.selectedTab) {
        case 0:
          this.checkPastDueEmpty();
          break;
        case 1:
          this.resetSelection = true;
          this.total = 0;
          this.enablePayBtn = false;
          if (!this.gridLoaded.c) {
            this.getPendingInvoices();
          }
          break;
        case 2:
          this.resetSelection = true;
          this.total = 0;
          this.enablePayBtn = false;
          if (!this.gridLoaded.d) {
            this.getPaidInvoices();
          }
          break;
      }
    }
  }

  showDialog() {
    if (this.ids) {
      this.getBankName();
    }
  }

  getEmpACHStatus() {
    this.invoiceService.getEmpACHStatus(this.inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.result !== undefined && data.result !== null && data.result > -1) {
        this.operators = this.authService.getAccessOperations(1);
        switch (data.result) {
          case 0:
            // bank info not found
            this.resetSelection = true;
            this.total = 0;
            this.noInfo = this.config.NoBankInfo;
            break;
          case 1:
            // ach debit
            break;
          // ach credit
          case 2:
            this.resetSelection = true;
            this.total = 0;
            this.noInfo = this.config.ACHCreditInfo;
            break;
        }
        this.getPastDueInvoices();
      } else if (data && data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.total = 0;
        this.resetSelection = true;
        this.notificationService.setErrorNotification();
      }
      this.loading = false;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.total = 0;
        this.loading = false;
        this.resetSelection = true;
        this.notificationService.setErrorNotification();
      });
  }

  getBankName() {
    this.paymentsService.getEmpBankInfo(this.inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.result) {
        this.disclaimer =
          this.config.AuthorizePayment.replace('{0}', this.authService.getCurrentOrgName())
            .replace('{1}', data.result.bankName)
            .replace('{2}', Utility.checkNegativeAmount(this.total))
            .replace('{3}', this.total < 0 ? 'neg-amount' : '');
        this.openDialog = true;
      } else {
        this.total = 0;
        this.loading = false;
        this.enablePayBtn = false;
        this.resetSelection = true;
        this.notificationService.setErrorNotification();
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.total = 0;
        this.loading = false;
        this.enablePayBtn = false;
        this.resetSelection = true;
        this.notificationService.setErrorNotification();
      });
  }

  closeDialog(status: string) {
    if (status === 'yes') {
      this.confirmPayment();
      this.enablePayBtn = false;
    } else {
      this.resetSelection = true;
      this.ids = [];
      this.openDialog = false;
      this.total = 0;
      this.enablePayBtn = false;
    }
  }

  confirmPayment() {
    this.loading = true;
    const submitPaymentData: any = { ...this.inputData };
    submitPaymentData.PaymentData = this.ids.sort((a: any, b: any) => a.id - b.id);
    const removeKeys = ['ShowDateError'];
    submitPaymentData.PaymentData.forEach((element, index) => {
      element.DueDate = Utility.formatHourDate(element.DueDate);
      removeKeys.forEach((key) => {
        delete element[key];
      });
      element.ScheduledDate = Utility.UTCTimestmpChange(new Date((new Date(element.ScheduledDate)).toDateString()));
      submitPaymentData.PaymentData[index] = element;
    });
    this.invoiceService.submitPayment(submitPaymentData).subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.result) {
        this.getAllInvoices();
        this.selectedTab = 0;
        if (data.result.length > 0) {
          data.result.forEach((element: any) => {
            this.notificationService.setErrorNotification(this.config.SubmitError + element);
          });
        } else {
          this.notificationService.setUpNotification({ message: this.config.SubmitSuccess, success: true });
        }
      } else if (data && data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.resetInvoiceSelection();
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.resetInvoiceSelection();
        this.notificationService.setErrorNotification();
      });
  }

  resetInvoiceSelection() {
    this.total = 0;
    this.loading = false;
    this.openDialog = false;
    this.resetSelection = true;
    this.ids = [];
    this.enablePayBtn = false;
  }

  expandDetailsBy = (dataItem: any): any => {
    return dataItem.invoiceType;
  }

  shouldDisplay(dataItem: any): boolean {
    return dataItem.shouldDisplay;
  }

  expandedDetailKeysChange(e: any) {
    if (e.length === 0) {
      this.ids = [];
      this.total = 0;
    } else if (e.length === 1 && e[0] === 'Due') {
      this.pastDueInvoices.forEach(element => {
        const pastdueIndex = this.ids.findIndex(x => x.id === element.id);
        if (pastdueIndex > -1) {
          this.ids.splice(pastdueIndex, 1);
          this.total = Math.round((this.total - element.amount) * 100) / 100;
        }
      });
    } else if (e.length === 1 && e[0] === 'Past Due') {
      this.dueInvoices.forEach(element => {
        const dueIndex = this.ids.findIndex(x => x.id === element.id);
        if (dueIndex > -1) {
          this.ids.splice(dueIndex, 1);
          this.total = Math.round((this.total - element.amount) * 100) / 100;
        }
      });
    }
    this.enablePayBtn = !(this.total === 0 || this.ids.some(x => x.ShowDateError));
  }
}
